import axios from 'axios';
import { config } from '../config/config';
import { authSession } from '../utils/authService';
import { showToast } from '../components/Toaster/Toaster';
import { NewProject } from '../components/NewProjectForm/NewProjectForm';
import moment from 'moment';

const API_URL = config.pythonBackendUrl;

export const fetchChatbotResponse = async (human: string): Promise<any> => {
    const token = await authSession();
    const chat_api = `${API_URL}/explainCode`
    try {
        const response = await axios.post(chat_api, { "query": human }, {
            headers: {
                'x-auth-token': process.env.REACT_APP_TOKEN,
                Authorization: `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching chatbot response:', error);
        showToast('Failed to get response from chatbot API', "error");
    }
};


export const fetchcachedResponse = async (p_id: string, fullFilePath: string): Promise<any> => {
    const token = await authSession();
    const chat_api = `${API_URL}/cacheData`
    try {
        const response = await axios.post(chat_api,
            {
                p_id,
                "fullFilePath": fullFilePath
            }, {
            headers: {
                'x-auth-token': process.env.REACT_APP_TOKEN,
                Authorization: `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching chatbot response:', error);
        showToast('Failed to get response from chatbot API', "error");
    }
};


export const fetchProjectDetails = async (pId: string) => {
    const token = await authSession();
    const detail_api = `${API_URL}/intro_cacheData?p_id=${pId}`
    console.log("token", process.env.REACT_APP_TOKEN)
    try {
        const response = await axios.get(detail_api, {
            headers: {
                'x-auth-token': process.env.REACT_APP_TOKEN,
                Authorization: `Bearer ${token}`
            }
        }
        );
        return response.data;
    } catch (error) {
        console.error('Error fetching chatbot response:', error);
        showToast('Failed to get response from chatbot API', "error");
    }

}

export const getAllProjects = async () => {
    const token = await authSession();
    const projects_api = `${API_URL}/get_all_projects`
    try {
        const response = await axios.get(projects_api, {
            headers: {
                'x-auth-token': process.env.REACT_APP_TOKEN,
                Authorization: `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        console.error("Error getting all projects: ", error);
        showToast('Failed to get all projects', "error");
    }
}

export const generateIntroData = async (data: NewProject) => {
    const token = await authSession();
    const projects_api = `${API_URL}/generateIntroData`
    try {
        const response = await axios.post(projects_api,
            {
                p_url: data.gitHubLink.trim(),
                p_name: data.projectName.trim(),
                p_main_branch: data.branchName.trim(),
                p_token: data.bitToken?.trim(),
                p_image_url: data.thumbnailImage?.name?.trim(),
                p_description: data.description?.trim()
            },
            {
                headers: {
                    'x-auth-token': process.env.REACT_APP_TOKEN,
                    Authorization: `Bearer ${token}`
                },
            });
        return response.data;
    } catch (error) {
        console.error("Error getting all projects: ", error);
        showToast('Failed to create new project', "error");
    }
}

export const getPresignedUrl = async (file: File, p_name: string) => {
    const s3BucketName = config.s3BucketName;
    const token = await authSession();
    const projects_api = `${API_URL}/get-presigned-url`;
    const key = `${s3BucketName}/${p_name}/${moment().unix()}-${file.name}`;
    try {
        const response = await axios.post(
            projects_api,
            { key },
            {
                headers: {
                    'x-auth-token': process.env.REACT_APP_TOKEN,
                    Authorization: `Bearer ${token}`
                },
            }
        );
        return response.data;
    } catch (error) {
        console.error("Error getting presigned URL: ", error);
        showToast('Failed to get presigned URL', "error");
    }
}
